import { ComponentProps } from 'react'

import Link from 'components/common/Link'

const REPORT_ISSUE_URL =
  'https://app.sendhark.com/new/6334a72e6f1b631d22cae649?is_embed=true'

const ReportIssue = ({
  buttonSize = 'medium',
}: {
  buttonSize?: ComponentProps<typeof Link>['size']
}) => {
  return (
    <Link
      linkType="external"
      rel="noreferrer noopener"
      size={buttonSize}
      target="_blank"
      to={REPORT_ISSUE_URL}
    >
      Report An Issue
    </Link>
  )
}

export default ReportIssue
